import { Agent } from "../../../model/Agent";
import { useSelectorKiosk } from "./useSelectorKiosk";

const useAgent = (): Agent => {
    const selector = useSelectorKiosk(state => state.agent)
    return selector;
}

export default useAgent;
